import type {
  PaginatedResponse,
  InformationalEventResource,
} from '@@/types/api';
import { useApi } from './use-api';

// List params intentionally keep the literal `'event_kind[]'` key: ofetch
// serializes it as `event_kind[]=rally&event_kind[]=expo`, which Laravel needs
// (bracket notation) to parse the value back into an array query param.
interface InformationalEventListParams {
  'event_kind[]'?: string[];
  date_from?: string;
  date_to?: string;
  page?: number;
  per_page?: number;
}

export function useInformationalEventsApi() {
  const { publicGet } = useApi('/api/v1/informational-events');

  return {
    list: (params?: InformationalEventListParams) =>
      publicGet<PaginatedResponse<InformationalEventResource>>('', {
        params: params as Record<string, unknown>,
      }),
    // DETAIL is a wrapped single resource (`{ data: {...} }`) — unwrap `.data`
    // here so callers get the bare resource, unlike the community `getEvent`.
    get: async (id: string): Promise<InformationalEventResource> => {
      const res = await publicGet<{ data: InformationalEventResource }>(
        `/${id}`,
      );
      return res.data;
    },
  };
}
